export enum UIEventType {
    CLICK = 'click',
    BLUR = 'blur',
    FOCUS = 'focus',
    MOUSELEAVE = 'mouseleave',
    MOUSEENTER = 'mouseenter',
    MOUSEDOWN = 'mousedown',
    MOUSEMOVE = 'mousemove',
    MOUSEUP = 'mouseup',
    MOUSEOVER = 'mouseover'
};
